import {iSolemnlySwearThisHtmlIsClean} from '../../../../../libs/shared/core/src/helpers/typescript/cleanHtml';

// This variable is interpolated on the backend.
//
// This is not declared in `survey.ts` because that module imports an image
// asset, which is not allowed on mobile.
export const surveyTemplateVariable = iSolemnlySwearThisHtmlIsClean('{{survey}}');
